(function () {
  'use strict';

  angular.module('unit.status').controller('unitStatusCtrl', unitStatusCtrl);

  unitStatusCtrl.$inject = [
    '$rootScope',
    '$scope',
    '$timeout',
    '$translate',
    'UnitStatus',
    'UnitCancelDealService',
    'SocketPusher',
    'localStorageService',
  ];

  function unitStatusCtrl(
    $rootScope,
    $scope,
    $timeout,
    $translate,
    UnitStatus,
    UnitCancelDealService,
    SocketPusher,
    localStorageService,
  ) {
    var vm = this;
    vm.lock = false;
    vm.showCancel = false;
    vm.hasLeadInWork = false;

    var textLeadConnection = $translate.instant(
      'unit.popup.unit.status.with.lead',
    );
    var textNoLeadConnection = $translate.instant(
      'unit.popup.unit.status.no.lead',
    );
    $rootScope.$on('$translateChangeSuccess', function () {
      textLeadConnection = $translate.instant(
        'unit.popup.unit.status.with.lead',
      );
      textNoLeadConnection = $translate.instant(
        'unit.popup.unit.status.no.lead',
      );
    });

    vm.unitStatuses = UnitStatus.get(function (statuses) {
      statuses.sort(function (a, b) {
        return a.type - b.type;
      });

      angular.forEach(statuses, function (status) {
        switch (status.type) {
          case '1':
            status.type_name = 'closed';
            break;
          case '2':
            status.type_name = 'free';
            break;
          case '3':
            status.type_name = 'reserved';
            break;
          case '4':
            status.type_name = 'sold';
            break;
        }
      });

      var resultIndex = statuses.findIndex(function (obj) {
        return obj.type == 3;
      });

      statuses.splice(resultIndex, 0, {
        id: '99',
        name: textLeadConnection,
        type: '0',
        type_name: 'group',
      });

      statuses.unshift({
        id: '100',
        name: textNoLeadConnection,
        type: '0',
        type_name: 'group',
      });

      changeStatusesDisabledState(statuses);
    });

    vm.unitStatusChange = function (statusId) {
      if (
        typeof vm.model === 'undefined' ||
        (vm.model.status && vm.model.status.id == statusId)
      )
        return;

      var oldStatus = vm.model.status;

      angular.forEach(vm.unitStatuses, function (unitStatus) {
        if (unitStatus.id == statusId) {
          confirmChangeStatus(
            oldStatus,
            unitStatus,
            function () {
              vm.model.status = unitStatus;
              updateStatus(oldStatus, unitStatus);
              if (
                unitStatus.type_name === 'reserved' ||
                (unitStatus.type_name === 'sold' && oldStatus.type !== '3')
              ) {
                vm.showCancel = true;
              }
            },
            function () {
              vm.model.status = oldStatus;
              vm.model.status_id = oldStatus.id;
            },
          );
        }
      });
    };

    vm.cancelStatusChange = function () {
      $rootScope.$broadcast('cancel.unit.reserved');
      vm.showCancel = false;
    };

    $scope.$on('cancel.unit.reserved', function (event) {
      changeStatusByName('free');
    });

    function changeStatusByName(statusName) {
      var oldStatus = vm.model.status;

      angular.forEach(vm.unitStatuses, function (unitStatus) {
        // проверяем, что устанавливаемый статус является дефолтным статусом системы
        if (unitStatus.type_name == statusName && unitStatus.lock == 1) {
          vm.model.status = unitStatus;
          vm.model.status_id = unitStatus.id;
          /*vm.model.status_type = unitStatus.type;*/
          updateStatus(oldStatus, unitStatus);
        }
      });
    }

    function confirmChangeStatus(oldStatus, newStatus, successCb, cancelCb) {
      if (oldStatus.type == '3' && newStatus.type == '2') {
        $rootScope.$broadcast('cancel.booking', {
          success: successCb,
          cancel: cancelCb,
        });
      } else {
        successCb();
      }
    }

    function updateStatus(oldStatus, newStatus) {
      if ($rootScope.unitId == vm.unitId) {
        $rootScope.$broadcast('unit.status.changed', {
          id: vm.unitId,
          new_status: newStatus,
          old_status: oldStatus,
        });

        var leadId = localStorage.getItem('leadId');
        UnitStatus.updateStatus(
          { unit_id: vm.unitId },
          { status_id: newStatus.id, lead_id: leadId },
          function () {
            $rootScope.$broadcast('activity.update');
          },
        );
      }
    }

    $scope.$on('lock.unit.deal.lead', function (event, state) {
      vm.unitStatuses.$promise.then(function () {
        angular.forEach(vm.unitStatuses, function (status) {
          if (status.id != vm.model.status_id) {
            status.disabled = state;
          }
        });
      });
    });

    $scope.$on('lock.unit.status.by.type', function (event, statusTypeOrName) {
      vm.unitStatuses.$promise.then(function () {
        angular.forEach(vm.unitStatuses, function (status) {
          if (statusTypeOrName === 'reserved') {
            if (
              (status.type_name === 'sold' && status.lock === '1') ||
              status.type_name === 'free' ||
              status.id === vm.model.status_id
            ) {
              status.disabled = false;
            } else {
              status.disabled = true;
            }
          } else if (statusTypeOrName === 'sold') {
            if (status.type_name !== 'sold') {
              status.disabled = true;
            }
          }
        });
        if (statusTypeOrName === 'reserved' || statusTypeOrName === 'sold') {
          vm.showCancel = false;
        }
      });
    });

    /*$scope.$watch('vm.model.status_id', function(newVal, oldVal){
            angular.forEach(vm.unitStatuses, function(status) {
                if (status.id == newVal) {
                    vm.model.status_type = status.type;
                }
            });
        });*/

    $scope.$on('socket.pusher.subscription_succeeded', function (event, data) {
      vm.activeUsers = data.members;

      // it would be great to start listening immediately after subscribe call
      // when the `channel` is available but subscription in performed in UnitPopupCtr
      // and `socket.pusher.subscription_succeeded` event is the only reliable way to be in sync
      SocketPusher.bind('status.lock', function (data) {
        if (data.user_id != SocketPusher.me().id) {
          vm.lock = true;
        }
      });

      SocketPusher.bind('status.unlock', function (data) {
        vm.lock = false;
      });

      if (
        vm.model.status_lock &&
        $rootScope.user_id != vm.model.lead_unit_assn.updated_by
      ) {
        $rootScope.$broadcast('unit.editing.show');
      } else if (
        typeof vm.model.lead_unit_assn !== 'undefined' &&
        $rootScope.user_id == vm.model.lead_unit_assn.updated_by
      ) {
        $rootScope.$broadcast('unit.editing.hide');
      }
    });

    $scope.$on('new.ls.lead', function (e, arg) {
      changeStatusesDisabledState(vm.unitStatuses);
    });

    function changeStatusesDisabledState(statuses) {
      if (localStorageService.get('lead')) {
        angular.forEach(statuses, function (status) {
          if (status.type === '3' || status.type === '4') {
            status.disabledNoLead = false;
          }
        });
        vm.hasLeadInWork = true;
      } else {
        angular.forEach(statuses, function (status) {
          if (status.type === '3' || status.type === '4') {
            status.disabledNoLead = true;
          }
        });
        vm.hasLeadInWork = false;
      }
    }
  }
})();
